export default {"src":"/_next/static/media/logoWhite.824bbb4b.svg","height":51,"width":196,"blurWidth":0,"blurHeight":0};